import { useEffect, useRef } from 'react';
import useApi from './useApi';
import { VesselSlimBM } from '../types/BusinessModel/Vessel/VesselSlimBM';
import { VesselFactory } from '../factory/Vessel/VesselFactory';
import { useVesselStore } from '../context/VesselContext';
import useApiEndpoints from '../context/useApiEndpoints';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { state, getApiData } = useApi();
    const { setVesselList, setFilteredVesselList, setIsVesselListRetrieved } = useVesselStore();
    const processApiEndpointErrorRef = useRef(processApiEndpointError);

    useEffect(() => {
        processApiEndpointErrorRef.current = processApiEndpointError;
    }, [processApiEndpointError]);

    const getVessels = () => {
        getApiData({
            endpoint: apiEndpoints['getVessels'].url,
            queryParam: '?fields=slim',
        });
    };

    useEffect(() => {
        if (state.status === 'success') {
            const vessels = state.result as VesselSlimBM[];
            const vesselFactory = new VesselFactory();
            const vesselList = vesselFactory.getVesselsSlim(vessels);
            setVesselList(vesselList);
            setFilteredVesselList(vesselList.filter((v) => v.isActive));
            setIsVesselListRetrieved(true);
        } else {
            processApiEndpointErrorRef.current(state);
        }
    }, [state, setFilteredVesselList, setIsVesselListRetrieved, setVesselList]);

    return { state, getVessels };
};
